export default __webpack_public_path__ + "static/media/done.3ba9e5cd.svg";